import { render, staticRenderFns } from "./OrderNumbersTable.vue?vue&type=template&id=6c8d18d0&"
import script from "./OrderNumbersTable.vue?vue&type=script&lang=js&"
export * from "./OrderNumbersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports